module.exports = __webpack_public_path__ + "static/media/10.77141cc7.jpg";